import React from "react";

function Service({ heading, para }) {
  return (
    <section className="layout-section pb-0 text-center">
      <div className="layout-container layout-container--narrow">
        <h1 id="heading-large">{heading}</h1>
        <p id="dark" className="mt-4 leading-relaxed text-justify sm:text-center">
          {para}
        </p>
      </div>
    </section>
  );
}

export default Service;
